export default "__VITE_ASSET__MIKvtfjk__"